export const BASE_URL =
  process.env.NODE_ENV === "development" ? "http://localhost:4000" : "https://api.thetarotgate.com";
export const BLOG_POSTS_URL = "/api/blog-posts";
export const FORUM_POSTS_URL = "/api/forum-posts";
export const USERS_URL = "/api/users";
export const COMMENTS_URL = "/api/comments";
export const IMAGES_URL = "/api/upload"
export const REPORTS_URL = "/api/reports"